import styles from "./VerifyEmailPage.module.css";
import { useMutation } from "@tanstack/react-query";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { postVerifyEmail } from "../../../../../http/auth.http";
import Spinner from "../../../../ui/progress/Spinner";

const VerifyEmailPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: postVerifyEmail,
    onSuccess: () => {
      let timeoutId = setTimeout(() => {
        navigate("/auth/signin", { replace: true });
      }, 5000);

      return () => clearTimeout(timeoutId);
    },
  });

  const verifyEmail = useCallback(() => {
    mutate(token);
  }, [mutate, token]);

  useEffect(() => {
    verifyEmail();
  }, [verifyEmail]);

  // console.log(token);

  let content = <p>Redirecting to dashboard</p>;

  if (isPending) {
    content = (
      <div className={styles["loading-wrapper"]}>
        <Spinner />
        Verifying email...
      </div>
    );
  }

  if (isSuccess) {
    content = (
      <div className={styles["success-wrapper"]}>
        <p>Account verified successfully</p>
        <p>You will be redirected to the login in 5 seconds</p>
      </div>
    );
  }

  if (isError) {
    content = <p>Something went wrong</p>;
  }

  return (
    <div className={styles.wrapper}>

      {content}
    </div>
  );
};

export default VerifyEmailPage;
